import { useState, useCallback } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import AIChatbot from "./components/AIChatbot";
import AILoader from "./components/AILoader";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import News from "./pages/News";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import AdminLogin from "./pages/AdminLogin";
import AdminSocialPost from "./pages/AdminSocialPost";
import Dashboard from "./pages/Dashboard";
import "./App.css";

function App() {
  const [loading, setLoading] = useState(true);
  const handleLoadComplete = useCallback(() => setLoading(false), []);

  return (
    <>
      {loading && <AILoader onComplete={handleLoadComplete} />}
      <Router>
        <div className={`min-h-screen bg-primary ${loading ? "opacity-0" : "opacity-100"} transition-opacity duration-500`}>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/social-posts" element={<AdminSocialPost />} />
          </Routes>
          <AIChatbot />
        </div>
      </Router>
    </>
  );
}

export default App;
